import React from 'react'
import ReactDOM from 'react-dom/client'
import { Main } from './components/Main'

const root = ReactDOM.createRoot(document.getElementById('interface') as HTMLElement)
root.render(<Main />)